export const doughnutsData = [
    {
        title:"CARGA TOTAL (%) Marzo 2019 - Abril 2020.",
        data:{
            labels: [
                'Maíz',
                'Soja',
                'Aceite',
                'Harina S.',
                'Fertilizante',
                'Pellet',
                'Gas Oil'
            ],
            datasets: [{
                data: [7, 81, 2,3,3,2,1],
                hoverOffset: 4
            }]
          }
    },
    {
        title:"CARGA - SENTIDO AGUAS ARRIBA (%) 04/19 - 03/20",
        data:{
            labels: [
                'Gas Oil','Fertilizante','Nafta','Aceite','Soja'
            ],
            datasets: [{
                data: [30, 53, 3,6,8],
                hoverOffset: 4
            }]
          }
    },
    {
        title:"CARGA - SENTIDO AGUAS ABAJO (%) 04/19 - 03/20",
        data:{
            labels: [
                'Soja','Maíz','Harinas S.', 'Pellet', 'Harina', 'Aceite'
            ],
            datasets: [{
                data: [85, 7, 3,3,2,1,2],
                hoverOffset: 4
            }]
          }
    },
    {
        title:"CARGA TOTAL (%) Abril 2018 - Marzo 2019",
        data:{
            labels: [
                'Maíz','Arroz','Soja','Aceites S.','Harina S.','Fertilizante','Pellet','S.Granell','Gas Oil','Trigo'
            ],
            datasets: [{
                data: [2, 3, 76,3,2,3,6,2,2,1],
                hoverOffset: 4
            }]
          }
    },
    {
        title:"CARGA - SENTIDO AGUAS ARRIBA (%) 04/18 - 03/19",
        data:{
            labels: [
                'Soja',
                'Gas Oil',
                'Nafta',
                'Trigo',
                'Fertilizante'
            ],
            datasets: [{
                data: [3, 32, 4,11,50],
                hoverOffset: 4
            }]
          }
    },
    {
        title:"CARGA - SENTIDO AGUAS ABAJO (%) 04/18 - 03/19",
        data:{
            labels: [
                'Soja','Maíz','Arroz','Aceites S.','Harinas S.','Pellet','S. Granel'
            ],
            datasets: [{
                data: [83, 2, 3,3,3,6,1],
                hoverOffset: 4
            }]
          }
    },
    {
        title:"CARGA TOTAL (%) Agosto 2017 - Julio 2018",
        data:{
            labels: [
                'Maíz','Arroz','Soja','Aceites S.','Aceite','Harina S.','Fertilizante','Pellet','S.Granel','Gas Oil'
            ],
            datasets: [{

                data: [1, 2, 76,1,1,7,3,7,1,1],
                hoverOffset: 4
            }]
          }
    },
    {
        title:"CARGA - SENTIDO AGUAS ARRIBA (%) 08/17 - 07/18",
        data:{
            labels: [
                'Pellet','Gas Oil','Aceite S.','Trigo','Fertilizante'
            ],
            datasets: [{

                data: [13, 14, 49,60],
                hoverOffset: 4
            }]
          }
    },
    {
        title:"CARGA - SENTIDO AGUAS ABAJO (%) 08/17 - 07/18",
        data:{
            labels: [
                'Soja','Arroz','Maíz','Aceites S.', 'Harinas S.', 'Pellet', 'S. Granel'
            ],
            datasets: [{
                data: [80, 3, 1,1,7,7,1],
                hoverOffset: 4
            }]
          }
    },
]